{% import FilterTitle from './title.monk' %}
<div class="filter {{ show ? '' : 'hidden' }}" >
  <FilterTitle title="{{title}}" collapsed="{{collapsed}}"/>
  <div class="filter-control-container {{ collapsed ? 'filter-control-container--collapsed' : '' }}">
    <div class="controll {{ collapsed ? 'hidden' : '' }}" role="filter-body">
      BaseBody
    </div>
  </div>
</div>
